import { useTranslation } from 'react-i18next';

import { getEmsServerUrl } from '@/api/baseUrls';
import { FaIcon, NgButtonNavLink } from '@/ui';

import type { ChecklistDto } from './checklistFiltering';

export type ChecklistListItemComponentProps = {
  checklist: ChecklistDto;
};

export function ChecklistListItemComponent({ checklist }: ChecklistListItemComponentProps) {
  const { t } = useTranslation();

  return (
    <div className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
      <div>
        <div className="d-flex align-items-center gap-2">
          <div>
            <FaIcon icon="fal fa-book" size="xl" cssClass="text-primary" />
          </div>
          <div>
            <h2 className="h6 mb-1">{checklist.title}</h2>
            <div className="small text-dark-emphasis">{checklist.description}</div>
          </div>
        </div>
      </div>
      <div>
        <NgButtonNavLink
          href={`${getEmsServerUrl()}/checklists/${checklist.id ?? ''}.pdf`}
          target="_blank"
          text={t('Button_Open')}
          icon="fal fa-file-pdf"
          cssClass="stretched-link"
        />
      </div>
    </div>
  );
}
